import { IconProps } from './types';

interface Props extends IconProps {
  fill: '#000' | '#fff' | 'inherit' | '#FF5C60';
}

export const MymePreviewLocationBasedIcon = (props: IconProps) => (
  <svg viewBox='0 0 16 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      // eslint-disable-next-line max-len
      d='M7.86781 0.800051C6.9394 0.799262 6.01995 0.981543 5.16207 1.33646C4.30418 1.69138 3.5247 2.21198 2.86822 2.86846C2.21173 3.52494 1.69114 4.30443 1.33622 5.16231C0.981299 6.0202 0.799018 6.93965 0.799807 7.86805C0.799807 13.1681 7.86781 20.9931 7.86781 20.9931C7.86781 20.9931 14.9358 13.1681 14.9358 7.86805C14.9366 6.93965 14.7543 6.0202 14.3994 5.16231C14.0445 4.30443 13.5239 3.52494 12.8674 2.86846C12.2109 2.21198 11.4314 1.69138 10.5735 1.33646C9.71566 0.981543 8.79621 0.799262 7.86781 0.800051V0.800051ZM7.86781 10.3921C7.36861 10.3921 6.88062 10.244 6.46555 9.96668C6.05048 9.68934 5.72697 9.29515 5.53593 8.83394C5.3449 8.37274 5.29492 7.86525 5.3923 7.37564C5.48969 6.88604 5.73008 6.4363 6.08307 6.08331C6.43606 5.73033 6.88579 5.48994 7.3754 5.39255C7.86501 5.29516 8.3725 5.34514 8.8337 5.53618C9.2949 5.72721 9.6891 6.05072 9.96644 6.46579C10.2438 6.88086 10.3918 7.36885 10.3918 7.86805C10.3915 8.53738 10.1255 9.17921 9.65225 9.6525C9.17897 10.1258 8.53713 10.3918 7.86781 10.3921V10.3921Z'
      stroke='black'
      strokeWidth='1.6'
      fill='#fff'
      {...props}
    />
  </svg>
);

export const MymeLocationBasedIcon = ({ fill, ...props }: Props) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 58.11 83.015'>
    <path
      // eslint-disable-next-line max-len
      d='M36.555,3A29.034,29.034,0,0,0,7.5,32.055c0,21.791,29.055,53.96,29.055,53.96S65.61,53.847,65.61,32.055A29.034,29.034,0,0,0,36.555,3Zm0,39.432A10.377,10.377,0,1,1,46.932,32.055,10.381,10.381,0,0,1,36.555,42.432Z'
      transform='translate(-7.5 -3)'
      fill={fill}
      {...props}
    />
  </svg>
);
